export const formatDateTime = (date: string | Date): string => {
  return new Date(date).toLocaleString()
}

export const getFormattedDate = (date?: string | Date) => {
  if (!date || date === '0001-01-01T00:00:00Z') return ''
  const day = typeof date === 'string' ? new Date(date) : date

  return day.toLocaleDateString('de-de', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  })
}

export const getFormattedDateAndTime = (isoString?: string | Date | null) => {
  if (!isoString) return ''
  const d = new Date(isoString)
  const date = d.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
  const time = d.toLocaleTimeString('de-DE', {
    hour: '2-digit',
    minute: '2-digit',
  })
  if (date === 'Invalid Date' || time === 'Invalid Date') return ''
  return `${date} um ${time} Uhr`
}
